import React from 'react';

import Image from '@components/elements/Image';

export function LogoIcon({ size = 24 }) {
  return <img src="/logo.png" alt="Logo" width={size} height={size} />;
}
